<template>

    <transition name="fade">

        <div v-if="show"
             class="toast-container"
             @click="close">

            <div class="toast">

                <span class="toast-text">{{ message }}</span>

            </div>

        </div>

    </transition>

</template>

<script>

export default {

    name: 'toast',

    data: () => {

        return {
            message: '',
            show: false
        }
    },

    methods: {

        open(str) {
            this.message = str || this.$t('cleaning_list_technical_error')
            this.show = true
            this.closeTimer()
        },

        close() {
            this.show = false
        },

        closeTimer() {
            const self = this
            setTimeout(function () {
                self.close()
            }, 3000)
        }
    }

}

</script>

<style lang="scss" scoped>

.toast-container {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    padding: 8px 16px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;

}

.toast {
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.2);
    background-color: $grey;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    z-index: 10;
    padding: 8px 16px;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 740px;
    }
}

.toast-text {
    font-size: 12px;
    line-height: 1.33;
    color: $white;
    text-align: left;
    width: 100%;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

</style>
